/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-children-prop */
import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  InputProps,
  InputRightAddon
} from "@chakra-ui/react";
import { ChangeEvent } from "react";
import { Control, Controller, FieldError, FieldValues, Path } from "react-hook-form";
import { IconType } from "react-icons";
import formatWithMask from "utils/masks/format-with-masks";
import { Mask } from "utils/masks/types";
import { TextGray } from "../../Texts/TextGray";

export interface InputTextMaskProps<T extends FieldValues> extends InputProps {
  name: Path<T>;
  mask: Mask;
  label?: string;
  icon?: IconType;
  error?: FieldError;
  control: Control<T>;
  rightIcon?: React.ReactNode;
}

export const InputTextMask = <T extends FieldValues>({
  name,
  label,
  control,
  error,
  mask,
  rightIcon: RightIconComponent,
  icon: IconComponent,
  ...props
}: InputTextMaskProps<T>) => {
  return (
    <FormControl isInvalid={!!error}>
      {!!label && (
        <FormLabel htmlFor={name} fontSize="sm">
          <Flex alignItems="center">
            {IconComponent && (
              <TextGray as="span" mr="1.5">
                <IconComponent />
              </TextGray>
            )}
            {label}
          </Flex>
        </FormLabel>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange, onBlur } }) => {
          const handleChange = (evt: ChangeEvent<HTMLInputElement>) => {
            const text = evt.currentTarget.value;
            if (mask) {
              const { masked } = formatWithMask({
                text,
                mask,
              });
              onChange(masked);
              evt.currentTarget.value = masked;
              props?.onChange?.(evt);
              return;
            }
            onChange(text);
            props?.onChange?.(evt);
          }

          return (
            <Input
              id={name}
              _placeholder={{ color: "gray.500" }}
              {...props}
              value={value}
              onChange={handleChange}
              onBlur={onBlur}
            />
          )
        }}
      />

      {!!error && (
        <FormErrorMessage mt="1" fontSize="xs">
          {error.message}
        </FormErrorMessage>
      )}
      {RightIconComponent && (
        <InputRightAddon>
          {RightIconComponent}
        </InputRightAddon>
      )}
    </FormControl>
  );
};
